import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

// material-ui
import { useTheme,  } from "@mui/material/styles";

import {
  Avatar,
  Box,
  Button,
  CardActions,
  ClickAwayListener,
  Divider,
  Grid,
  Paper,
  Popper,
  Stack,
  Typography,
  useMediaQuery,

  Badge,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { connect, useSelector } from "react-redux";

import PerfectScrollbar from "react-perfect-scrollbar";

import MainCard from "ui-component/cards/MainCard";
import Transitions from "ui-component/extended/Transitions";

import { getUnreadData } from "store/slices/notificationAction";
// assets
import { IconBell } from "@tabler/icons";
import {
  getNotification,
  notificationAlert,
} from "store/slices/notificationAction";
import moment from "moment";
import "moment/locale/en-in";

import "moment/locale/is";

import "moment/locale/pl";
import "moment/locale/es";
import useRecursiveTimeout from "../../../../layout/MainLayout/Sidebar/MenuList/useRecursiveTimeout";


// ==============================|| NOTIFICATION ||============================== //

const NotificationSection = (props) => {
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down("md"));
  const { ownerLabelsName } = props.label;
  const [open, setOpen] = useState(false);
  const notifications = useSelector((state) => state.notifications);
  const { notificationData } = notifications;
  const unreads = notificationData;

  useEffect(() => {
    props.getUnreadData();
  }, []);

  /**
   * anchorRef is used on different componets and specifying one type leads to other components throwing an error
   * */
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
    props.getUnreadData();
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  const lng = localStorage.getItem("Lng");
  const { notificationLoading, notificationList } = notifications;
  const rows = notificationList?.docs;

  useEffect(() => {
    props.getNotification(1, 20, "");
    if (open) {
      const notify = [];
      let b = rows.length;
      for (let i = 0; i < 3; i++) {
        notify.push(rows[i]?._id);
      }
      if (notify.length > 0) {
        let datas = { id: notify, flag: 2 };
        props.notificationAlert(datas);
      }
    }
  }, [open]);

  useRecursiveTimeout(async () => {
    props.getNotification(1, 20, "");
  }, 10000);



  const handleListItemClick = () => {
    setOpen(false);
  };

      if (!['en-in', 'is', 'pl', 'es'].includes(lng)) {
  
        moment.locale('en');  // fallback to English if the locale is not supported
      } else {
        moment.locale(lng); // Set locale dynamically
      }

  return (
    <>
      <Box
        sx={{
          ml: 2,
          mr: 3,
          [theme.breakpoints.down("md")]: {
            mr: 2,
          },
        }}
      >
        <Badge badgeContent={unreads} color="primary">
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: "all .2s ease-in-out",
              background:
                theme.palette.mode === "dark"
                  ? theme.palette.dark.main
                  : theme.palette.secondary.light,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.warning.dark
                  : theme.palette.secondary.dark,
              '&[aria-controls="menu-list-grow"],&:hover': {
                background:
                  theme.palette.mode === "dark"
                    ? theme.palette.warning.dark
                    : theme.palette.secondary.dark,
                color:
                  theme.palette.mode === "dark"
                    ? theme.palette.grey[800]
                    : theme.palette.secondary.light,
              },
            }}
            ref={anchorRef}
            aria-controls={open ? "menu-list-grow" : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
            color="inherit"
          >
            <IconBell stroke={1.5} size="1.3rem" />
          </Avatar>
        </Badge>
      </Box>

      <Popper
        placement={matchesXs ? "bottom" : "bottom-end"}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [matchesXs ? 5 : 0, 20],
              },
            },
          ],
        }}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClose}>
            <Transitions
              position={matchesXs ? "top" : "top-right"}
              in={open}
              {...TransitionProps}
            >
              <Paper
                sx={{
                  [theme.breakpoints.down("md")]: {
                    mx: 1.5,
                  },
                  [theme.breakpoints.down("sm")]: {
                    mx: 0,
                  },
                  ".css-5k5fng-MuiPaper-root-MuiCard-root": {
                    margin: 0,
                  },
                }}
              >
                {open && (
                  <MainCard
                    border={false}
                    content={false}
                    elevation={16}
                    boxShadow
                    shadow={theme.shadows[16]}
                    style={{ marginLeft: "0px", marginRight: "0px" }}
                  >
                    <Grid container direction="column" spacing={2}>
                      <Grid item xs={12}>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{ pt: 2, px: 2 }}
                        >
                          <Grid item>
                            <Stack direction="row" spacing={2}>
                              <Typography variant="subtitle1">
                                {ownerLabelsName
                                  ? ownerLabelsName.filter(
                                      (e) => e.key == "lbl_notification"
                                    ).length > 0
                                    ? ownerLabelsName.filter(
                                        (e) => e.key == "lbl_notification"
                                      )[0]["value"] || "lbl_notification"
                                    : "lbl_notification"
                                  : "lbl_notification"}
                              </Typography>
                            </Stack>
                          </Grid>
                          <Grid item></Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <PerfectScrollbar
                          style={{
                            height: "100%",
                            maxHeight: "calc(100vh - 205px)",
                            overflowX: "hidden",
                          }}
                        >
                          {/* <Grid
                            container
                            direction="column"
                            spacing={2}
                            sx={{ mb: 0.3, mt: 0.2 }}
                          >
                            <Grid item xs={12} p={0}>
                              <Divider sx={{ my: 0 }} />
                            </Grid>
                          </Grid> */}
                          <Divider sx={{ my: 0 }} />

                          <List
                            sx={{
                              marginTop: "15px",
                              width: "100%",
                              width: 330,
                              maxWidth: 330,
                              py: 0,
                              borderRadius: "10px",
                              [theme.breakpoints.down("md")]: {
                                maxWidth: 300,
                              },
                              [theme.breakpoints.down("sm")]: {
                                width: "100%",
                                maxWidth: 250,
                              },
                              "& .MuiListItemSecondaryAction-root": {
                                top: 32,
                              },
                              "& .MuiDivider-root": {
                                my: 0,
                              },
                              "& .list-container": {
                                pl: 7,
                                mt: -1,
                              },
                              "& .MuiListItemText-primary": {
                                mt: -2,
                              },
                            }}
                          >
                            <ListItemText>
                              {!notificationLoading &&
                                rows.length > 0 &&
                                rows.map((noti, i) => {
                                  if (i < 3) {
                                    return (
                                      <>
                                        <Divider />
                                        <Grid
                                          container
                                          spacing={0.5}
                                          className="notification"
                                          sx={{ mt: 0.2, mb: 0.2 }}
                                        >
                                          <Link
                                            to="/notification"
                                            style={{
                                              cursor: "pointer",
                                              textDecoration: "none",
                                              color: "#616161",
                                            }}
                                          >
                                            <ListItemButton
                                              onClick={handleListItemClick}
                                            >
                                              <Grid
                                                item
                                                xs={12}
                                                sx={{ m: 2, mb: 1 }}
                                              >
                                                <Grid
                                                  container
                                                  alignItems="center1"
                                                  spacing={1}
                                                >
                                                  <Grid
                                                    xs={3}
                                                    sm={2.5}
                                                    sx={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    {noti?.admin?.profile_pic ? (
                                                      <Avatar
                                                        alt="John Doe"
                                                        src={
                                                          noti?.admin
                                                            ?.profile_pic
                                                        }
                                                        sx={{
                                                          marginTop: "0px",
                                                        }}
                                                      />
                                                    ): <Avatar
                                                    alt="John Doe"
                                                    src={
                                                      noti?.user
                                                        ?.profile_pic
                                                    }
                                                    sx={{
                                                      marginTop: "0px",
                                                    }}
                                                  />}
                                               
                                                  </Grid>
                                                  <Grid
                                                    container
                                                    xs={9}
                                                    sm={9.5}
                                                    spacing={0}
                                                  >
                                                    <Grid item xs={12}>
                                                      <Typography>
                                                        {noti.title}
                                                      </Typography>
                                                    </Grid>
                                                    <Grid
                                                      item
                                                      xs={12}
                                                      sx={{ pt: 0 }}
                                                    >
                                                      <Grid
                                                        container
                                                        alignItems="center"
                                                        justifyContent="space-between"
                                                      >
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          sm={7}
                                                        >
                                                          <Typography variant="subtitle2">
                                                            {noti?.content}
                                                          </Typography>
                                                        </Grid>
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          sm={5}
                                                          sx={{
                                                            textAlign: "end",
                                                          }}
                                                        >
                                                          <Typography variant="caption">
                                                            {moment(
                                                              noti.createdAt
                                                            )
                                                              .locale(lng)
                                                              .startOf(
                                                                "seconds"
                                                              )
                                                              .fromNow()}
                                                          </Typography>
                                                        </Grid>
                                                      </Grid>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            </ListItemButton>
                                          </Link>
                                        </Grid>
                                      </>
                                    );
                                  }
                                })}
                              {!notificationLoading &&
                                notificationList.docs.length === 0 && (
                                  <Grid
                                    item
                                    xs={12}
                                    display="flex"
                                    justifyContent="center"
                                  >
                                    <Typography gutterBottom sx={{ mt: 2 }}>
                                      {ownerLabelsName
                                        ? ownerLabelsName.filter(
                                            (e) =>
                                              e.key ==
                                              "lbl_no_notification_found"
                                          ).length > 0
                                          ? ownerLabelsName.filter(
                                              (e) =>
                                                e.key ==
                                                "lbl_no_notification_found"
                                            )[0]["value"] ||
                                            "lbl_no_notification_found"
                                          : "lbl_no_notification_found"
                                        : "lbl_no_notification_found"}
                                    </Typography>
                                  </Grid>
                                )}
                            </ListItemText>
                          </List>

                          {/* <NotificationList open={open} onClick={open} /> */}
                        </PerfectScrollbar>
                      </Grid>
                    </Grid>
                    <Divider />
                    <CardActions sx={{ p: 1.25, justifyContent: "center" }}>
                      <Link
                        to="/notification"
                        style={{ textDecoration: "none" }}
                      >
                        <Button
                          size="small"
                          disableElevation
                          onClick={(e) => {
                            setOpen(false);
                          }}
                        >
                          {ownerLabelsName
                            ? ownerLabelsName.filter((e) => e.key == "lbl_view_all")
                                .length > 0
                              ? ownerLabelsName.filter(
                                  (e) => e.key == "lbl_view_all"
                                )[0]["value"] || "lbl_view_all"
                              : "lbl_view_all"
                            : "lbl_view_all"}
                        </Button>
                      </Link>
                    </CardActions>
                  </MainCard>
                )}
              </Paper>
            </Transitions>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  );
};

const mapStateToProps = (state) => ({
  label: state.language,
});

export default connect(mapStateToProps, {
  getUnreadData,
  getNotification,
  notificationAlert,
})(NotificationSection);
